/**
 * Layout constants for consistent spacing and sizing across the app
 */

/**
 * Header/AppBar heights matching MUI Toolbar defaults
 * - xs: Mobile devices
 * - sm: Tablet and desktop
 */
export const HEADER_HEIGHT = {
  xs: 56,
  sm: 64,
} as const;

/**
 * Default header height for calculations (uses desktop size)
 */
export const HEADER_HEIGHT_DEFAULT = HEADER_HEIGHT.sm;

/**
 * MainLayout's content padding on each side below md (`p: { xs: 2, sm: 3 }`)
 */
export const MAIN_CONTENT_PADDING = {
  xs: 16,
  sm: 24,
} as const;

/**
 * CSS variable ImpersonationBanner sets on the root element to its rendered height while it is shown
 */
export const IMPERSONATION_BANNER_HEIGHT_VAR = '--impersonation-banner-height';

/**
 * Height of a mobile page that fills the space MainLayout leaves below its app bar and impersonation banner
 */
export const MOBILE_PAGE_HEIGHT = {
  xs: `calc(100dvh - ${HEADER_HEIGHT.xs + 2 * MAIN_CONTENT_PADDING.xs}px - var(${IMPERSONATION_BANNER_HEIGHT_VAR}, 0px))`,
  sm: `calc(100dvh - ${HEADER_HEIGHT.sm + 2 * MAIN_CONTENT_PADDING.sm}px - var(${IMPERSONATION_BANNER_HEIGHT_VAR}, 0px))`,
} as const;

/**
 * Drawer width for navigation sidebar
 */
export const DRAWER_WIDTH = 240;

/**
 * MUI Accordion animation duration in milliseconds
 * Used for scroll synchronization during accordion expansion
 */
export const ACCORDION_ANIMATION_DURATION = 300;

/**
 * Default scroll padding from top of viewport (in pixels)
 * Used when scrolling elements into view to avoid being flush with the top
 */
export const SCROLL_PADDING_TOP = 16;
